<template>
    <div class="pageDiv">
      <v-card class="main-card" v-if="tournament===null">
            <v-card-title v-if="!$AuthSvc.isFw()">
                <span class="page-title">Group Pairings</span>
                <br>
            </v-card-title>

            <v-card-text v-if="registerTournaments.length > 1">
                <v-card-text v-if="registerTournaments !== null && registerTournaments.length > 1">
                    <v-card-title>
                        Select course to show groupings:
                    </v-card-title>

                    <v-card-text>
                        <div v-for="tn in registerTournaments" :key="tn.tournament.tournamentId" style="padding:5px 10px; width:100%;text-align:left;">
                            <div class="select-btn" @click="selectTournament(tn)">
                              <span style="display:inline-block;padding-top:7px;;text-align:left;margin-right:20px">
                                {{printDateTime(tn.tournament.scheduleDate)}}
                              </span>
                                <span style="display:inline-block;padding-top:7px;text-align:left;">
                                {{tn.course!==null?tn.course.name:''}}
                              </span>
                              <span> ({{$AuthSvc.printFormat(tn.tournament.formatType)}}) </span>
                            </div>
                        </div>
                    </v-card-text>
                </v-card-text>
            </v-card-text>

            <v-card-text v-if="registerTournaments.length===0">
                <span class="label14">
                    Group pairings are not available.
                </span>
            </v-card-text>
        </v-card>

        <v-card class="main-card" v-if="tournament!==null">
            <v-card-title>
                <span class="page-title"  v-if="!$AuthSvc.isFw()"> Group Pairings: ({{numberOfPlayers}} players)</span>
                <br>
                <span class="label18">{{course.name}} Golf Course</span>
            </v-card-title>

            <br><br>
            <div v-if="tournament.itinerary !== ''" class="message">
              <span class="messageText" v-html="tournament.itinerary"></span>
              <br>
            </div>

            <v-card-text class="groupPairingCard">
                <div class="group-card" v-for="(group, index) in groups" :key="group">
                    <v-simple-table class="simple-table">
                        <tr>
                            <th width="350px">
                                Group
                                <span v-if="group.teeBox==='null' || group.teeBox==='' || group.teeBox==='NULL'"> {{index+1}}: </span>
                                <span v-if="group.teeBox!=='null' && group.teeBox!=='' && group.teeBox!=='null' && group.teeBox!=='NULL'">
                                    Hole: {{group.teeBox}}
                                </span>
                                <a class="scoreCardLabel" v-if="tournament.formatType === 'FUN'" @click="scoreCard(group.groupId)">Score Card</a>
                            </th>

                            <th v-if="tournament.status !== 'ACTIVE'">FLT</th>
                            <th v-if="tournament.status === 'ACTIVE'">SCORE</th>

                            <th v-if="tournament.status !== 'ACTIVE'">HCP</th>
                            <th v-if="tournament.status === 'ACTIVE'">THRU</th>
                        </tr>
                        <tr v-for="player in group.players" :key="player">
                            <td :class="{a_team: player.team === 'B'}">
                              {{getName(player)}}
                              <v-img class="member-logo" v-if="player.memberId > 0" src="../../assets/img/okaga-logo-mini.png">
                              </v-img>
                            </td>

                            <td :class="{a_team: player.team === 'B'}" v-if="tournament.status !== 'ACTIVE'">
                              {{player.flight}}
                            </td>
                            <td :class="{a_team: player.team === 'B'}" class="label20" v-if="tournament.status === 'ACTIVE'">
                              {{getScore(player)}}
                            </td>

                            <td :class="{a_team: player.team === 'B'}" class="label20" v-if="tournament.status !== 'ACTIVE'">
                              {{player.handicap}}
                            </td>
                            <td :class="{a_team: player.team === 'B'}" class="label20" v-if="tournament.status === 'ACTIVE'">
                              {{getThruHoles(player)}}
                            </td>
                        </tr>
                    </v-simple-table>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import moment from 'moment';
import TextareaEmojiPicker from '../TextareaEmojiPicker';
import tinymce from 'tinymce';
import emojione from 'emojione';

tinymce.init({
  selector: "#mytextarea",
  plugins: "emoticons autoresize",
  toolbar: "emoticons",
  toolbar_location: "bottom",
  menubar: false,
  statusbar: false
});
  export default {
    name: "Grouping",
    components: { TextareaEmojiPicker },
    data: () => ({
      showEmojiPicker: false,
      players: {},
      tournament: null,
      course: null,
      groups: null,
      numberOfPlayers: 0,
      registerTournaments: [],
      subject: '',
      message: '',
      currentPost: null,
      feedbacks: [],
      text: ''
    }),
    mounted: function() {
     var _this = this;

      _this.tournament = null;
      _this.course == null;

      const urlParams = new URLSearchParams(window.location.search);
      const id = urlParams.get('id')
      if (id !== null && id !== '') {
        _this.$CommandSvc.get(_this, '/public/tournament-course/' + id, function(data) {
          if (data !== null) {
            _this.tournament = data.tournament;
            _this.course = data.course;
            _this.loadPlayers(_this.tournament);
            _this.loadFeedbacks();
            _this.autoLoadFeedback();
          }
        });
      } else {
        _this.$CommandSvc.get(_this, '/public/tournaments/status/PAIRINGS', function(data) {
          _this.registerTournaments = data;
          if (_this.registerTournaments !== null && _this.registerTournaments.length === 1) {
            _this.course = _this.registerTournaments[0].course;
            _this.tournament = _this.registerTournaments[0].tournament;
            _this.loadPlayers(_this.tournament);
          }

          _this.registerTournaments.sort((a, b) => {
            if ( moment(a.tournament.scheduleDate).isAfter(b.tournament.scheduleDate) ) {
              return 1;
            }
            else {
              return -1;
            }
          });

          _this.loadFeedbacks();
          _this.autoLoadFeedback();
        });
      }
    },
    methods: {
      addEmoji(ch) {
        this.message += ' ' + ch;
        console.log("MSG: " + this.message);
      },
      toggleEmojiPicker () {
        this.showEmojiPicker = !this.showEmojiPicker
      },
      autoLoadFeedback() {
        setTimeout(() => {
          this.loadFeedbacks();
          this.$forceUpdate();
          this.autoLoadFeedback();
        }, 20000);
      },
      printFBDateTime(date) {
        return moment(date).format('hh:mm A');
      },
      printDateTime(date) {
        return moment(date).format('MM/DD hh:mm A');
      },
      getScore(player) {
        if (this.tournament.formatType === 'MATCH_PLAY' || this.tournament.formatType === 'FUN_FW_TEAM') {
          if (player.team === 'A') {
            if (player.matchScore === null || player.matchScore === 0) {
              return 'A/S';
            }
            else {
              return player.matchScore;
            }
          }
        }
        else {
          if (player.thruHoles < 18) {
            if (player.toPar === 0) {
              return "E";
            }
            else if (player.toPar > 0) {
              return "+" + player.toPar;
            }
            else {
              return player.toPar;
            }
          }
          else {
            return player.score;
          }
        }
      },
      getThruHoles(player) {
        if (this.tournament.formatType === 'MATCH_PLAY' || this.tournament.formatType === 'FUN_FW_TEAM') {
          if (player.team === 'A') {
            return player.thruHoles < 18 ? player.thruHoles : "F";
          }
        }
        else {
          return player.thruHoles < 18 ? player.thruHoles : "F";
        }
      },
      flightCode(flight) {
        if (flight === 'Nicklaus') {
            return 'Nick';
        }
        else if (flight === 'Palmer') {
            return 'Palm';
        }
        else {
            return 'Hogan';
        }
      },
      selectTournament(tn) {
        this.course=tn.course;
        this.tournament = tn.tournament;
        window.location.href = "/grouping?id=" + tn.tournament.tournamentId;
      },
      scoreCard(groupId) {
        console.log('SCORE CARD: ' + groupId);
        window.location.href = '/scoring?id=' + groupId;
      },
      getName(player) {
        if (player !==  null && player.firstName !== undefined) {
          if (this.$AuthSvc.isFw() && ['FUN_FW','FUN_FW_TEAM'].includes(this.tournament.formatType) && player.nickName !== null) {
            return player.nickName;
          }
          return player.firstName + " " +
           (player.middleName!==null && player.middleName!==''?player.middleName.charAt(0):'')
            + " " + player.lastName;
        }
        return "";
      },
      loadPlayers(tournament) {
        var _this = this;

        this.axios.get('/public/scores/score-card/group/' + tournament.tournamentId)
        .then(function (response) {
            var i;
            var players = response.data;

            _this.numberOfPlayers = 0;

            var size = 0;
            for(i=0; i < players.length; i++) {
              if (players[i].groupId > size) {
                size = players[i].groupId;
              }
            }

            _this.groups = new Array(size);

            for(i=0; i < size; i++) {
              _this.groups[i] = {
                groupId: i+1,
                players: new Array()
              }
            }

            for(i=0; i < players.length; i++) {
              const gId = players[i].groupId;
              if (gId > 0) {
                _this.groups[gId-1].teeBox = players[i].teeBox;
                _this.groups[gId-1].players.push(players[i]);
                _this.numberOfPlayers++
              }
            }
        })
        .catch(function (error) {
            console.log('ERROR: ' + error);
        });
      },
      loadFeedbacks() {
        var _this = this;
        _this.axios.get('/public/smack/' + this.tournament.tournamentId)
            .then(function (response) {
              _this.feedbacks = response.data;
            })
            .catch(function (error) {
              console.log('ERROR: ' + error);
            });
      },
      processKey(event) {
        if (event.keyCode === 13) {
          this.postMessage();
        }
      },
      postMessage() {
        var _this = this;

        if (_this.message !== null && _this.message.length > 0) {
          var reply = {
            groupId: 0,
            postedTime: null,
            userid: _this.$AuthSvc.getNickName() !== null ? _this.$AuthSvc.getNickName() : _this.$AuthSvc.getUserid(),
            subject: '',
            message: this.message,
            tournamentId: _this.tournament.tournamentId
          };

          _this.axios.post('/public/feedbacks', reply)
              .then(function (response) {
                console.log(response.data);
                _this.loadFeedbacks();
                _this.message = '';
                this.$forceUpdate();
              })
              .catch(function (error) {
                console.log('ERROR: ' + error);
              });
        }
      }
    },
  }

</script>

<style scoped>

    li {
      margin-bottom: 5px;
    }

    .group-card {
        width: 100%;
        float: left;
        margin: 10px 0;
    }

    .scoreCardBtn {
        font-size: 10px;
        font-weight: bold;
        float: right;
        background-color: #f2d3db !important;
        height: 26px !important;
        padding: 0 5px !important;
    }


    .groupPairingCard {
        margin-top: 20px;
        display: inline-block;
    }

    .scoreCardLabel {
        font-size: 12px;
        font-weight: bold;
        color: gold;
    }

    .emojiBtn {
      font-size: 50px;
      margin-left: 15px;
    }

    @media (min-width: 768px) {
        .group-card {
          margin: 10px;
        }

        td {
          font-size: 14px !important;
        }

        .group-card {
           width: 360px;
           height: 200px;
           vertical-align: top;
        }

        .emojiBtn {
          font-size: 28px !important;
        }
    }

    span {
      height: 12px !important;
    }

    .hideIt {
      display: none;
    }

    .post {
      background-color: #dae0dd;
      padding: 5px !important;
      border-radius: 5px;
      width: 98% !important;
    }

    .first-message span {
      display: inline-block;
      width: 98%;
    }

    .reply-message span {
      display: inline-block;
      width: 98%;
      margin-left: 20px !important;
    }

    .post .v-card__text {
      padding: 0px !important;
      margin: 0px 5px!important;
    }


    input, textarea {
      display: inline-block;
      padding: 5px;
      border: 1px solid black;
      border-radius: 5px;
      width: 100%;
    }

    .feedback-card {
      display: inline-block;
      border: 1px solid black;
      border-radius: 5px;
      padding: 10px;
      width: 100%;
    }

    .feedback-card-text {
      display: flex;
      margin-top:10px !important;
      width:100%;
      height: 400px;
      padding: 5px 10px !important;
      overflow-y: scroll;
      flex-direction: column-reverse;
      border: 2px solid black;
      border-radius: 7px;
      margin-bottom: 7px;
    }

    .enter-text {
      display: inline-block;
      border: 3px solid black;
      width: 85%;
      font-size: 18px;
      font-weight: bold;
    }

    .member-logo {
      display: inline-block;
      height: 20px;
      width: 20px;
      border-radius: 45px;
      margin-left: 10px;
    }

    @media (min-width: 768px) {
      .enter-text {
        width: 93%;
      }
    }

    .primary-btn {
      display: inline-block;
      height: 36px;
      position: absolute;
      margin-left: 10px;
      padding: 5px 10px !important;
      border-radius: 8px;
    }

</style>